/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Tag_Filters_LabelInputs */



/**
* | output |
* | --- |
* | "Tag filters" |
*
* @param {Editor_Tag_Filters_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_tag_filters_label = /** @type {((inputs?: Editor_Tag_Filters_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Tag_Filters_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filtres d'etiquettes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tag-Filter")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filtri per tag")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Фильтры тегов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Filtros de etiquetas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标签筛选器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タグフィルター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टैग फ़िल्टर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Filtros de tags")
	return /** @type {LocalizedString} */ ("Tag filters")
});